import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/api/shipment/getBatchList&list'],
  post: ['/api/shipment/setBatch']
})